import Input from 'b2b-ui-components-lib/lib/components/input';
import { alphaNumericValidatorWithSpecialCharacters, emailValidaotr, mobileValidator } from 'common/utils/validator';

export const CPM_DETAILS_FORM_CONFIG = {
  name: {
    key: 'name',
    isMandatory: true,
    value: '',
    label: 'Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: alphaNumericValidatorWithSpecialCharacters,
    element: { type: Input }
  },
  mobileNumber: {
    key: 'mobileNumber',
    isMandatory: true,
    value: '',
    label: 'Mobile Number',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    validator: mobileValidator,
    element: { type: Input, props: { maxlength: 10 } }
  },
  emailAddress: {
    key: 'emailAddress',
    isMandatory: true,
    value: '',
    label: 'Email Address',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: emailValidaotr,
    element: { type: Input }
  }
};

export const SITE_READINESS_OPTIONS = [
  {
    id: 'Yes',
    displayName: (
      <div className="site_ready_option">
        <div className="title">Yes, the site is ready.</div>
        <div className="sub_title info">Upon order confirmation, our agent will visit the site.</div>
      </div>
    )
  },
  {
    id: 'No',
    displayName: (
      <div className="site_ready_option">
        <div className="title">No, the site needs work.</div>
        <div className="sub_title warn">This may delay the installation process.</div>
      </div>
    )
  }
];
export const CPM_DETAILS_FORM_CONFIG_EDL = {
  dcpFirstName: {
    key: 'dcpFirstName',
    isMandatory: true,
    value: '',
    label: 'First Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: alphaNumericValidatorWithSpecialCharacters,
    element: { type: Input }
  },
  dcpLastName: {
    key: 'dcpLastName',
    isMandatory: false,
    value: '',
    label: 'Last Name',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: alphaNumericValidatorWithSpecialCharacters,
    element: { type: Input }
  },
  dcpPhoneNumber: {
    key: 'dcpPhoneNumber',
    isMandatory: true,
    value: '',
    label: 'Mobile Number',
    className: 'flg-lg-6 flg-md-6 flg-sm-12 row_section',
    validator: mobileValidator,
    element: { type: Input, props: { maxlength: 10 } }
  },
  dcpEmail: {
    key: 'dcpEmail',
    isMandatory: true,
    value: '',
    label: 'Email Address',
    className: 'flg-lg-6 flg-md-6 flg-sm-12',
    validator: emailValidaotr,
    element: { type: Input }
  }
};
